// extracted by mini-css-extract-plugin
module.exports = {"notificationsContainer":"NotificationContainer_notificationsContainer__itJOO"};